import React, { useEffect } from 'react';
import { Grid, Box } from '@mui/material';
import { ReactComponent as Check } from "../../../assets/dashboardIcons/checkIcon.svg"
import { ReactComponent as Weather } from "../../../assets/dashboardIcons/WeatherIcon.svg"
import  Temp1  from "../../../assets/Temp1.png"
import  Temp2  from "../../../assets/Temp2.png"
import  Temp3  from "../../../assets/Temp3.png"
import  Temp4  from "../../../assets/Temp4.png"
import  Temp5  from "../../../assets/Temp5.png"
import Temp6 from "../../../assets/Temp6.png"
import Temp7 from "../../../assets/Temp7.png"
import Temp8 from "../../../assets/Temp8.png"
import { ReactComponent as Sun } from "../../../assets/dashboardIcons/SunIcon.svg"
import { useDispatch, useSelector } from 'react-redux';
import { selectError, selectIsLoading, selectSingleSensori, selectWeatherData } from '../../../features/sensori/sensoriSlice';
import { fetchWeatherData } from '../../../features/sensori/sensoriThunk';

// const weatherData = [
//   { label: 'Temperatura', value: '-3°', icon: Weather, active: true },
//   { label: 'Umidità', value: '-3°', icon: Water, active: true },
//   { label: 'Pressione', value: '-3°', icon: Direction, active: true },
//   { label: 'Carica batterica', value: '-3°', icon: Weather, active: false },
//   { label: 'Pioggia', value: '-3°', icon: Light, active: false },
//   { label: 'Vento', value: '-3°', icon: Flow, active: false },
//   { label: 'Punto di rugiada', value: '-3°', icon: Rain, active: false },
//   { label: 'Sole', value: '-3°', icon: Sun, active: false }
// ];

const WeatherCards = () => {

  const dispatch = useDispatch();
  const weatherData = useSelector(selectWeatherData);
  const isLoading = useSelector(selectIsLoading);
  const error = useSelector(selectError);
  const singleId = useSelector(selectSingleSensori)
  const locationTable = weatherData?.weatherData || [];
  console.log("locationTable",locationTable);
  console.log(singleId,'wekfjdewnfkm');
  
  useEffect(() => {
    
    // debugger
    dispatch(fetchWeatherData())
      .then((data) => {
        console.log('Weather data fetched successfully:', data);
      })
      .catch((error) => {
        console.error('Error fetching weather data:', error);
      });
  }, [dispatch]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  let Tempicons = singleId.company_id===35 && singleId.sensore_name === 'seafish' ? [Temp6,Temp7,Temp8,Temp5] : [Temp1,Temp2,Temp3,Temp4,Temp5]

  return (
<Box className="WeatherCards" mb={3} container spacing={2} justifyContent="center">
{locationTable?.map((item, index) => {
  const IconComponent = Tempicons[index % Tempicons.length];
  return (
    <Box item xs={2} key={index}>
      <Box className={item?.active ? "temperaturaBox" : "temperaturaBox disabled"}>
        <Box className="temperaturaBox__top">
          {item.active && (
            <Check className="tagIcon" />
          )}
          <Box className="temperaturaBox__icon">
            <img src={IconComponent} alt="" />
          </Box>
          <h4 style={{ color: "#225CA6" }}>
            {item.value}
          </h4>
        </Box>
        <h2
          className="temperaturaBox__title"
          style={{ color: item.active ? '#225CA6' : '#F9F9F9' }}
        >
          {item.label}
        </h2>
      </Box>
    </Box>
  );
})}
</Box>

    // <div>
    //   {weatherData?.weatherData?.map((item, index) => (
    //     <div key={index}>
    //       <h3>{item.label}</h3>
    //       <p>Value: {item.value}</p>
    //       <p>Status: {item.active ? 'Active' : 'Inactive'}</p>
    //     </div>
    //   ))}
      
    // </div>
  );
};

export default WeatherCards;